const state = {
	name: '',
};

const getters = {
	name: state => state.name,
};

const mutations = {
	name(state, path) {
		state.name = path;
	},
};

const actions = {};


export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}